/**
 * Single source of truth for the company name across the whole project.
 *
 * Consumed by both the Next.js app (src/lib/brand.ts) and the standalone
 * PDF-generation scripts (scripts/*.mjs). It is a plain .mjs module so that
 * `node` scripts can import it directly and Next can bundle it without a
 * TypeScript build step.
 *
 */
export const COMPANY_NAME = "BSFI Consulting";

/**
 * Canonical production origin (no trailing slash). Used for the sitemap,
 * robots.txt, and canonical URLs.
 */
export const SITE_URL = "https://consulting.bsfi.fr";
